module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "modal error has-text-left",
    class: {
      'is-active': _vm.ErrorModal.active
    }
  }, [_c('div', {
    staticClass: "modal-background"
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-card"
  }, [_c('header', {
    staticClass: "modal-card-head"
  }, [_c('button', {
    staticClass: "delete",
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  })]), _vm._v(" "), _c('section', {
    staticClass: "modal-card-body"
  }, [_c('div', {
    staticClass: "columns"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('p', {
    staticClass: "title is-4"
  }, [_vm._v(_vm._s(_vm.ErrorModal.text))])])])]), _vm._v(" "), _c('footer', {
    staticClass: "modal-card-foot right"
  }, [_c('a', {
    staticClass: "button",
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_vm._v("OK")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column is-2"
  }, [_c('span', {
    staticClass: "icon is-large has-text-primary is-pulled-left"
  }, [_c('i', {
    staticClass: "fa fa-times-circle"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-20caf14a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ErrorModal.vue
// module id = 727
// module chunks = 0